const CORE_API_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_CORE_API_URL
    : process.env.REACT_APP_CORE_API_STAGING_URL;

const jsonHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json'
});

// The AppUser JWT issued by /identity/api/otp/verify - separate from
// localStorage.jwt (micro-back's own Devise-JWT session, unrelated) and
// localStorage.fjwt (the embedded Twist/logistics iframe token). Nothing
// else in this app reads this key.
const authHeaders = () => ({
  ...jsonHeaders(),
  Authorization: `Bearer ${localStorage.getItem('appUserJwt') || ''}`
});

// Talks directly to the parrotfy Core monolith (CORS-restricted to this
// app's origin), NOT to parrotfy-micro-back - this is the unified OTP login
// + tenant picker, which micro-back has no involvement in.
export default class CoreApi {
  static requestOtp(email) {
    return fetch(`${CORE_API_URL}/otp`, {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ email })
    });
  }

  static verifyOtp(email, otp) {
    return fetch(`${CORE_API_URL}/otp/verify`, {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ email, otp })
    });
  }

  static fetchTenants() {
    return fetch(`${CORE_API_URL}/tenants`, {
      method: 'GET',
      headers: authHeaders()
    });
  }

  static requestTenantRedirect(subdomain) {
    return fetch(`${CORE_API_URL}/tenants/${subdomain}/redirect_url`, {
      method: 'POST',
      headers: authHeaders()
    });
  }
}
